import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Header from "components/Header";
import { routes } from "constants/routes";
import useDeviceType from "hooks/useDeviceType";
import MainLayout from "layouts/Main";
import { IFactoringPaymentProfile } from "models/HaulPay";
import { getCarrierGroupsAPI, getFactoringPaymentProfilesAPI } from "services/api/haulpay";
import { selectUserDetails } from "store/user/selector";
import ConnectHaulPayCarriers from "./modules/ConnectHaulPayCarriers";
import InviteByEmailAddress from "./modules/InviteByEmail";
import styles from "./style.module.scss";

interface ICarrierGroup {
  id: string;
  name: string;
  type: string;
}

export default function BrokerCarrierAddNew() {
  const userDetails = useSelector(selectUserDetails);
  const { isDesktop } = useDeviceType();
  const [carrierGroups, setCarrierGroups] = useState<ICarrierGroup[]>([]);
  const [paymentProfilesAll, setPaymentProfilesAll] = useState<IFactoringPaymentProfile[]>([]);

  useEffect(() => {
    const getCarrierGroups = async () => {
      const { data: groups } = await getCarrierGroupsAPI();
      setCarrierGroups(groups.results);

      const { data: profiles } = await getFactoringPaymentProfilesAPI(userDetails.factoring_id);
      setPaymentProfilesAll(profiles.results);
    };

    if (userDetails?.factoring_id) {
      getCarrierGroups();
    }
  }, [userDetails?.factoring_id]);

  return (
    <MainLayout
      desktopTitle="My Carriers"
      customHeader={
        <Header
          label={isDesktop ? "Add a New Carrier" : "Add New"}
          goBackPath={routes.HAULPAY_BROKER_CARRIERS}
        />
      }
      className={styles.addNewContainer}>
      <div className={styles.cardWrapper}>
        <ConnectHaulPayCarriers />

        <InviteByEmailAddress
          paymentProfilesAll={paymentProfilesAll}
          carrierGroups={carrierGroups}
        />
      </div>
    </MainLayout>
  );
}
